// HOTFIX-UPLOAD-1: ids and counts only. Never file names or document text.
export const BULK_PENDING_MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000;

export function bulkPendingKey(projectId) {
  return `stratalogy.bulkPending.${projectId}`;
}

export function writeBulkPending(projectId, record) {
  const payload = {
    projectId,
    sessionIds: record.sessionIds || [],
    batchSizes: record.batchSizes || [],
    savedAt: record.savedAt || new Date().toISOString(),
  };
  try {
    localStorage.setItem(bulkPendingKey(projectId), JSON.stringify(payload));
  } catch {
    // A full or blocked store must not break the upload.
  }
}

export function readBulkPending(projectId, now = Date.now()) {
  let raw;
  try {
    raw = localStorage.getItem(bulkPendingKey(projectId));
  } catch {
    return null;
  }
  if (!raw) return null;
  let parsed;
  try {
    parsed = JSON.parse(raw);
  } catch (err) {
    return null;
  }
  if (!parsed || parsed.projectId !== projectId || !Array.isArray(parsed.sessionIds) || !parsed.sessionIds.length) {
    return null;
  }
  const saved = Date.parse(parsed.savedAt);
  if (!Number.isFinite(saved) || now - saved >= BULK_PENDING_MAX_AGE_MS) return null;
  return {
    projectId,
    sessionIds: parsed.sessionIds,
    batchSizes: Array.isArray(parsed.batchSizes) ? parsed.batchSizes : [],
    savedAt: parsed.savedAt,
  };
}

export function clearBulkPending(projectId) {
  try {
    localStorage.removeItem(bulkPendingKey(projectId));
  } catch {
    // Same as a missing key: the wizard can still open.
  }
}

export function pendingFileCount(record) {
  return (record && record.batchSizes ? record.batchSizes : []).reduce((sum, count) => sum + (Number(count) || 0), 0);
}
